import React, {Component} from 'react';
import {Input} from 'reactstrap';
import PropTypes from 'prop-types';

export default class TextArea extends Component {

    _correctSize(target) {
        target.style.height = 'auto';
        target.style.height = `${target.scrollHeight}px`;
    }

    render() {
        return (
            <>
            {this.props.disabled ? (
                  <Input
                  value={this.props.value}
                  name={this.props.name}
                  onChange={(e) => {
                      this.props.onChange(e);
                      this._correctSize(e.target)
                  }}
                  onBlur={this.props.onBlur}
                  disabled={this.props.disabled}
                  style={{backgroundColor: "#DFDFDF"}}
                  type='textarea'
              />
            ):(
                <Input
                value={this.props.value}
                name={this.props.name}
                onChange={(e) => {
                    this.props.onChange(e);
                    this._correctSize(e.target)
                }}
                onBlur={this.props.onBlur}
                disabled={this.props.disabled}
                type='textarea'
            />
            )}
            </>
          
        )
    }

}

TextArea.propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func,
    onBlur: PropTypes.func
}
